import Joi from 'joi';

export const LSPSchema = Joi.object({
  deleteManagerVerificationField: Joi.string().required().messages({
    'string.empty': 'Please type word "DELETE"',
    'any.required': 'Please type word "DELETE"',
  }),
});
